/*
  Add here your own custom javascript codes
*/

document.addEventListener('DOMContentLoaded', function () {
  function initCardListToggles(root=document){
    var groups = root.querySelectorAll('.btn-toggle-layout');
    groups.forEach(function(group){
      var sectionId = group.getAttribute('data-section-id');
      var container = document.querySelector('.card-list[data-section-id="' + sectionId + '"]');
      // fallback: find closest .card-list parent
      if(!container){
        var el = group.closest('.card-list');
        container = el;
      }
      var sectionSelector = '.card-list[data-section-id="' + sectionId + '"]';
      var cardList = group.closest('.card-list');
      var key = 'card-list-layout-' + (sectionId || 'global');

      function applyMode(mode){
        if(mode === 'list'){
          cardList.classList.add('layout-list');
          cardList.classList.remove('layout-grid');
          group.querySelector('.js-cardlist-list').classList.add('active');
          group.querySelector('.js-cardlist-grid').classList.remove('active');
        } else {
          cardList.classList.add('layout-grid');
          cardList.classList.remove('layout-list');
          group.querySelector('.js-cardlist-grid').classList.add('active');
          group.querySelector('.js-cardlist-list').classList.remove('active');
        }
      }

      // load saved preference
      var saved = null;
      try{ saved = localStorage.getItem(key); }catch(e){}
      applyMode(saved === 'list' ? 'list' : 'grid');

      group.addEventListener('click', function(e){
        var btn = e.target.closest('button');
        if(!btn) return;
        if(btn.classList.contains('js-cardlist-list')){
          applyMode('list');
          try{ localStorage.setItem(key, 'list'); }catch(e){}
        } else if(btn.classList.contains('js-cardlist-grid')){
          applyMode('grid');
          try{ localStorage.setItem(key, 'grid'); }catch(e){}
        }
      });
    });
  }

  initCardListToggles(document);
  // init clear-cart buttons
  (function initClearCartButtons(){
    document.querySelectorAll('.btn-clear-cart').forEach(function(btn){
      btn.addEventListener('click', async function(e){
        e.preventDefault();
        var confirmMsg = 'Are you sure you want to remove all items from the cart?';
        if(!window.confirm(confirmMsg)) return;
        try{
          btn.disabled = true;
          btn.classList.add('loading');
          var res = await fetch('/cart/clear.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest' } });
          if(!res.ok) throw new Error('Network response was not ok');
          // reload to reflect empty cart
          window.location.reload();
        }catch(err){
          console.error('Clear cart failed', err);
          btn.disabled = false;
          btn.classList.remove('loading');
          alert('Unable to clear cart. Please try again.');
        }
      });
    });
  })();

  // Ensure variant selects never have a disabled option selected
  (function initVariantSelectGuards(){
    document.querySelectorAll('form select[name="id"]').forEach(function(select){
      // Ensure data-available attributes are respected (in case other scripts override)
      Array.prototype.slice.call(select.options).forEach(function(opt){
        if(opt.dataset && typeof opt.dataset.available !== 'undefined'){
          opt.disabled = (opt.dataset.available === 'false' || opt.dataset.available === '0');
        }
      });
      function ensureValid(){
        var selectedOption = select.options[select.selectedIndex];
        if(selectedOption && selectedOption.disabled){
          // pick first enabled option
          for(var i=0;i<select.options.length;i++){
            if(!select.options[i].disabled){
              select.selectedIndex = i;
              selectedOption = select.options[i];
              break;
            }
          }
        }
        // enable/disable submit based on availability
        var form = select.closest('form');
        if(form){
          var submit = form.querySelector('[type="submit"]');
          if(submit){
            var anyEnabled = Array.prototype.slice.call(select.options).some(function(opt){ return !opt.disabled; });
            submit.disabled = !anyEnabled;
          }
        }
      }

      // run once on init
      ensureValid();

      // on change, enforce
      select.addEventListener('change', function(){
        // if user somehow selected a disabled option, revert
        var opt = select.options[select.selectedIndex];
        if(opt && opt.disabled){
          ensureValid();
        }
        ensureValid();
      });
    });
  })();

  // Product media gallery lightbox
  (function initProductLightbox(){
    var lightbox = null;
    function createLightbox(){
      lightbox = document.createElement('div');
      lightbox.className = 'product-lightbox';
      lightbox.setAttribute('hidden', '');
      lightbox.innerHTML = "<button class='product-lightbox-close' aria-label='Close'>&times;</button>" +
        "<button class='product-lightbox-prev' aria-label='Previous'>&lsaquo;</button>" +
        "<div class='product-lightbox-content'><img src='' alt=''></div>" +
        "<button class='product-lightbox-next' aria-label='Next'>&rsaquo;</button>";
      document.body.appendChild(lightbox);

      lightbox.querySelector('.product-lightbox-close').addEventListener('click', closeLightbox);
      lightbox.addEventListener('click', function(e){ if(e.target === lightbox) closeLightbox(); });
      lightbox.querySelector('.product-lightbox-prev').addEventListener('click', function(e){ e.stopPropagation(); navigate(-1); });
      lightbox.querySelector('.product-lightbox-next').addEventListener('click', function(e){ e.stopPropagation(); navigate(1); });
      document.addEventListener('keydown', function(e){
        if(!lightbox || lightbox.hasAttribute('hidden')) return;
        if(e.key === 'Escape') closeLightbox();
        if(e.key === 'ArrowLeft') navigate(-1);
        if(e.key === 'ArrowRight') navigate(1);
      });
    }

    function openLightbox(images, index){
      if(!lightbox) createLightbox();
      lightbox.images = images;
      lightbox.current = index || 0;
      updateLightboxImage();
      lightbox.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
    }

    function closeLightbox(){
      if(!lightbox) return;
      lightbox.setAttribute('hidden', '');
      document.body.style.overflow = '';
    }

    function navigate(dir){
      if(!lightbox) return;
      var l = lightbox.images.length;
      lightbox.current = (lightbox.current + dir + l) % l;
      updateLightboxImage();
    }

    function updateLightboxImage(){
      if(!lightbox) return;
      var imgEl = lightbox.querySelector('.product-lightbox-content img');
      var src = lightbox.images[lightbox.current];
      imgEl.src = src;
    }

    // Delegate clicks from gallery zoom buttons or main images
    document.body.addEventListener('click', function(e){
      var zoomBtn = e.target.closest('.product-media-gallery-zoom');
      var imgClicked = null;
      if(e.target && e.target.tagName === 'IMG') imgClicked = e.target;
      else imgClicked = e.target.closest && e.target.closest('.product-media-gallery img');
      if(!zoomBtn && !imgClicked) return;
      // find the gallery root
      var gallery = (zoomBtn ? zoomBtn.closest('.product-media-gallery') : (imgClicked ? imgClicked.closest('.product-media-gallery') : null));
      if(!gallery) return;
      // collect image sources in this gallery
      var imgs = Array.prototype.slice.call(gallery.querySelectorAll('.swiper-main img')).map(function(i){ return i.src; });
      if(imgs.length === 0) return;
      // determine index
      var index = 0;
      if(zoomBtn){
        var idx = zoomBtn.getAttribute('data-media-index');
        index = idx ? parseInt(idx,10) : 0;
      } else if(imgClicked){
        index = imgs.indexOf(imgClicked.src);
        if(index < 0) index = 0;
      }
      openLightbox(imgs, index);
    });
  })();
  // Disclosure / localization selector behavior (toggle, outside click, keyboard nav)
  (function initLocalizationDisclosure(){
    document.querySelectorAll('.disclosure').forEach(function(root){
      var btn = root.querySelector('.disclosure__button');
      var listWrapper = root.querySelector('.disclosure__list-wrapper');
      var list = root.querySelector('.disclosure__list');
      if(!btn || !listWrapper || !list) return;

      var links = Array.prototype.slice.call(list.querySelectorAll('a'));

      function open(){
        listWrapper.hidden = false;
        btn.setAttribute('aria-expanded','true');
        // focus first link
        if(links.length) links[0].focus();
      }
      function close(){
        listWrapper.hidden = true;
        btn.setAttribute('aria-expanded','false');
      }

      btn.addEventListener('click', function(e){
        e.preventDefault();
        if(listWrapper.hidden) open(); else close();
      });

      // Close when clicking outside the disclosure
      document.addEventListener('click', function(e){
        if(!root.contains(e.target)) close();
      });

      // Close on Escape and allow toggling with Enter/Space on the button
      document.addEventListener('keydown', function(e){
        if(e.key === 'Escape') close();
      });

      // Keyboard navigation inside the list
      links.forEach(function(link, idx){
        link.addEventListener('keydown', function(ev){
          if(ev.key === 'ArrowDown'){ ev.preventDefault(); var n=(idx+1)%links.length; links[n].focus(); }
          if(ev.key === 'ArrowUp'){ ev.preventDefault(); var n=(idx-1+links.length)%links.length; links[n].focus(); }
          if(ev.key === 'Home'){ ev.preventDefault(); links[0].focus(); }
          if(ev.key === 'End'){ ev.preventDefault(); links[links.length-1].focus(); }
        });
      });
    });
  })();
  
 
  // Bundle selection enforcement: limit total to 2 pieces and mirror selections to hidden property
  (function initBundleSelection(){
    function getAllBoxes(){
      return Array.prototype.slice.call(document.querySelectorAll('.bundle-qty-checkbox'));
    }

    function updateHidden(){
      var mapping = {};
      getAllBoxes().forEach(function(b){
        if(b.checked){
          var img = b.dataset.imageUrl || '';
          var val = Number(b.dataset.value || b.value) || 0;
          mapping[img] = val;
        }
      });
      var hidden = document.querySelector('input[name="properties[bundle_selection]"]');
      if(hidden) hidden.value = JSON.stringify(mapping);
    }

    function computeTotal(){
      var total = 0;
      getAllBoxes().forEach(function(b){ if(b.checked) total += Number(b.dataset.value || b.value) || 0; });
      return total;
    }

    function setDisabledState(total){
      var boxes = getAllBoxes();
      // value currently selected per group
      var groupValue = {};
      boxes.forEach(function(b){
        if(!groupValue[b.name]) groupValue[b.name] = 0;
        if(b.checked) groupValue[b.name] = Number(b.dataset.value || b.value) || 0;
      });

      boxes.forEach(function(b){
        if(b.checked){
          b.disabled = false;
          if(b.parentElement) b.parentElement.classList.remove('disabled');
          return;
        }
        var currentInGroup = groupValue[b.name] || 0;
        var prospective = (total - currentInGroup) + (Number(b.dataset.value || b.value) || 0);
        if(prospective > 2){
          b.disabled = true;
          if(b.parentElement) b.parentElement.classList.add('disabled');
        } else {
          b.disabled = false;
          if(b.parentElement) b.parentElement.classList.remove('disabled');
        }
      });
    }

    function onCheckboxChange(e){
      var box = e.target;
      // ensure mutual exclusivity in group: uncheck other checkboxes with same name
      var siblings = Array.prototype.slice.call(document.querySelectorAll('input[name="' + box.name + '"]'));
      if(box.checked){
        siblings.forEach(function(s){ if(s !== box) s.checked = false; });
      }

      var total = computeTotal();
      if(total > 2){
        // revert
        box.checked = false;
        total = computeTotal();
      }

      setDisabledState(total);
      updateHidden();
    }

    var initialBoxes = getAllBoxes();
    if(initialBoxes.length === 0) return;
    initialBoxes.forEach(function(b){ b.addEventListener('change', onCheckboxChange); });

    // initialize disabled state and hidden input value from any pre-selected boxes
    setDisabledState(computeTotal());
    updateHidden();
  })();
});

  // Scroll-to-top behavior
document.addEventListener('DOMContentLoaded', function () {
  var btn = document.getElementById('scroll-to-top');
  if(!btn) return;
  var showAt = 300;

  function update() {
    if (window.scrollY > showAt) btn.classList.add('visible'); else btn.classList.remove('visible');
  }

  window.addEventListener('scroll', update, { passive: true });
  update();

  btn.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    btn.blur();
  });
});


// Secondary category drawer toggle (delegated, supports dynamic sections)
(function(){
  function findWrapper(el){ return el && el.closest && el.closest('.secondary-category-wrapper'); }

  function getDrawerFor(wrapper, toggle){
    if(!wrapper) return null;
    var drawerId = toggle && toggle.getAttribute ? toggle.getAttribute('aria-controls') : null;
    if(drawerId){
      try { return wrapper.querySelector('#' + drawerId); } catch(e) { /* fallthrough */ }
    }
    return wrapper.querySelector('.secondary-category-drawer');
  }

  function openDrawer(wrapper, drawer, toggle){
    if(!drawer || !wrapper) return;
    drawer.hidden = false;
    var overlay = wrapper.querySelector('.secondary-category-overlay');
    if(overlay) overlay.hidden = false;
    requestAnimationFrame(function(){ drawer.classList.add('open'); if(overlay) overlay.classList.add('visible'); });
    if(toggle) toggle.setAttribute('aria-expanded','true');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer(wrapper, drawer, toggle){
    if(!drawer || !wrapper) return;
    drawer.classList.remove('open');
    var overlay = wrapper.querySelector('.secondary-category-overlay');
    if(overlay) overlay.classList.remove('visible');
    if(toggle) toggle.setAttribute('aria-expanded','false');
    document.body.style.overflow = '';
    setTimeout(function(){ drawer.hidden = true; if(overlay) overlay.hidden = true; }, 260);
  }

  // Click delegation for toggle, close button, and overlay
  document.addEventListener('click', function(e){
    var toggle = e.target.closest && e.target.closest('.secondary-category-toggle');
    if(toggle){
      e.preventDefault();
      var wrapper = findWrapper(toggle);
      var drawer = getDrawerFor(wrapper, toggle);
      if(!drawer) return;
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      if(expanded) closeDrawer(wrapper, drawer, toggle); else openDrawer(wrapper, drawer, toggle);
      return;
    }

    var closeBtn = e.target.closest && e.target.closest('.drawer-close');
    if(closeBtn){
      var wrapper = findWrapper(closeBtn);
      var toggleFor = wrapper && wrapper.querySelector('.secondary-category-toggle');
      var drawer = getDrawerFor(wrapper, toggleFor || closeBtn);
      closeDrawer(wrapper, drawer, toggleFor);
      return;
    }

    var overlay = e.target.closest && e.target.closest('.secondary-category-overlay');
    if(overlay){
      var wrapper = findWrapper(overlay);
      var toggleFor = wrapper && wrapper.querySelector('.secondary-category-toggle');
      var drawer = getDrawerFor(wrapper, toggleFor || overlay);
      closeDrawer(wrapper, drawer, toggleFor);
      return;
    }
  }, true);

  // Close any open drawers on Escape
  document.addEventListener('keydown', function(e){
    if(e.key !== 'Escape') return;
    document.querySelectorAll('.secondary-category-drawer.open').forEach(function(drawer){
      var wrapper = drawer.closest('.secondary-category-wrapper');
      var toggleFor = wrapper && wrapper.querySelector('.secondary-category-toggle');
      closeDrawer(wrapper, drawer, toggleFor);
    });
  });
})();

// Copy-to-clipboard handler for `.copy-text` icons (delegated)
(function(){
  function fallbackCopyText(text){
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.style.position = 'fixed';
    ta.style.left = '-9999px';
    document.body.appendChild(ta);
    ta.select();
    try{ document.execCommand('copy'); }catch(e){ console.warn('fallback copy failed', e); }
    document.body.removeChild(ta);
  }

  function showCopiedFeedback(btn){
    var orig = btn.getAttribute('aria-label') || '';
    btn.setAttribute('aria-label','Copied');
    btn.classList.add('copied');
    setTimeout(function(){ btn.setAttribute('aria-label', orig); btn.classList.remove('copied'); }, 1200);
  }

  document.addEventListener('click', function(e){
    var el = e.target.closest && e.target.closest('.copy-text');
    if(!el) return;
    e.preventDefault();
    var value = el.getAttribute('data-copy-value');
    if(!value){
      var parent = el.closest('.SKU_code');
      if(parent){
        var txt = '';
        parent.childNodes.forEach(function(node){ if(node.nodeType === Node.TEXT_NODE){ var t = node.nodeValue.trim(); if(t) txt = t; }});
        value = txt;
      }
    }
    if(!value) return;
    if(navigator.clipboard && navigator.clipboard.writeText){
      navigator.clipboard.writeText(value).then(function(){ showCopiedFeedback(el); }).catch(function(){ fallbackCopyText(value); showCopiedFeedback(el); });
    } else {
      fallbackCopyText(value);
      showCopiedFeedback(el);
    }
  }, true);

  // keyboard activation (Enter / Space)
  document.addEventListener('keydown', function(e){
    var target = e.target && e.target.closest && e.target.closest('.copy-text');
    if(!target) return;
    if(e.key === 'Enter' || e.key === ' '){
      e.preventDefault();
      target.click();
    }
  });
})();
// Simple slider initializer for `.adjustable-slider-wrap`
(function(){
  function initSliders(){
    document.querySelectorAll('.adjustable-slider-wrap').forEach(function(wrap){
      var track = wrap.querySelector('.adjustable-slider');
      var prev = wrap.querySelector('.adjustable-slider-prev');
      var next = wrap.querySelector('.adjustable-slider-next');
      var dotsContainer = wrap.querySelector('.adjustable-slider-dots');
      if(!track) return;

      // Collect slide elements (direct children)
      var slides = Array.prototype.slice.call(track.children).filter(function(n){ return n.nodeType===1; });

      // Ensure slide cards are focusable for accessibility
      slides.forEach(function(slide){
        var card = slide.querySelector('.product-card') || slide;
        if(card && !card.hasAttribute('tabindex')) card.setAttribute('tabindex','0');
      });

      // Create/refresh dots
      if(dotsContainer){
        dotsContainer.innerHTML = '';
        slides.forEach(function(_, i){
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.setAttribute('aria-label','Go to slide '+(i+1));
          btn.className = (i===0) ? 'active' : '';
          btn.addEventListener('click', function(){ slides[i].scrollIntoView({ behavior: 'smooth', inline: 'center' }); });
          dotsContainer.appendChild(btn);
        });
      }

      // Helper: determine centered slide index
      function getCenteredSlideIndex(){
        var trackRect = track.getBoundingClientRect();
        var centerX = trackRect.left + trackRect.width / 2;
        var closest = 0; var closestDist = Infinity;
        slides.forEach(function(slide, i){ var r = slide.getBoundingClientRect(); var slideCenter = r.left + r.width/2; var d = Math.abs(centerX - slideCenter); if(d < closestDist){ closestDist = d; closest = i; }});
        return closest;
      }

      function updateDots(index){ if(!dotsContainer) return; Array.prototype.slice.call(dotsContainer.children).forEach(function(b,i){ b.classList.toggle('active', i===index); }); }

      // Prev/Next navigate per-slide
      if(prev) prev.addEventListener('click', function(){ var i = getCenteredSlideIndex(); var target = Math.max(0, i-1); slides[target].scrollIntoView({ behavior: 'smooth', inline: 'center' }); });
      if(next) next.addEventListener('click', function(){ var i = getCenteredSlideIndex(); var target = Math.min(slides.length-1, i+1); slides[target].scrollIntoView({ behavior: 'smooth', inline: 'center' }); });

      // keyboard support for prev/next
      if(prev) prev.addEventListener('keydown', function(e){ if(e.key === 'Enter' || e.key === ' ') { e.preventDefault(); var i = getCenteredSlideIndex(); var target = Math.max(0, i-1); slides[target].scrollIntoView({ behavior: 'smooth', inline: 'center' }); }});
      if(next) next.addEventListener('keydown', function(e){ if(e.key === 'Enter' || e.key === ' ') { e.preventDefault(); var i = getCenteredSlideIndex(); var target = Math.min(slides.length-1, i+1); slides[target].scrollIntoView({ behavior: 'smooth', inline: 'center' }); }});

      // On scroll, update active dot and focus nearest slide after debounce
      var debounceTimer = null;
      track.addEventListener('scroll', function(){ if(debounceTimer) clearTimeout(debounceTimer); debounceTimer = setTimeout(function(){ var idx = getCenteredSlideIndex(); updateDots(idx); var focusedCard = slides[idx].querySelector('.product-card') || slides[idx]; focusedCard && focusedCard.focus(); }, 120); });
    });
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSliders); else initSliders();
})();